<span class="badge"
      [ngClass]="{
        'badge--inline': inline,
        'badge--dark': dark
      }">
  <ng-content></ng-content>
</span>
